import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './periodic-account-review-modal.magic.css.js';
import script from './periodic-account-review-modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"periodic-account-review-modal",attrs:{"part":"periodic-account-review-modal","data-v-test-id":"periodic-account-review-modal"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","data-v-test-id":"periodic-account-review-description","content":_vm.$t('periodic-account-review.modal-text')},on:{"click":_vm.closeModal}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"button",attrs:{"small":"","variant":"primary","data-v-test-id":"periodic-account-review-submit","loading":_vm.isLoading},domProps:{"innerHTML":_vm._s(_vm.$t('periodic-account-review.modal-button'))},on:{"click":_vm.acknowledge}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-c4cf2f5a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-c4cf2f5a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
